import { UserInteractionServiceV1 } from '@volkswagen-onehub/user-interaction-service';

export function actionRedirect(
	userInteractionService: UserInteractionServiceV1,
	action: string,
) {
	const [actionPath, paramString] = action.split('?');
	const handlerName = actionPath.replace('action:', '');
	const handler = userInteractionService.get(handlerName);

	const params: Record<string, string | string[]> = {};
	let paramsActionActivate = '';

	// Reset si no viene dealer en paramString → poner uno “neutral”
	if (!paramString || !paramString.includes('dealer=')) {
		params.dealer = 'none';
		paramsActionActivate = 'dealer=none';
	}

	if (paramString) {
		paramsActionActivate = paramString;
		const paramPairs = paramString.split('&');

		paramPairs.forEach(pair => {
			const [key, value] = pair.split('=');
			params[key] = value;
		});
	}

	// @ts-ignore
	handler.onActivate(params, paramsActionActivate);
}
